export const FavoritesSection = {
  title: 'Favourite',
  removeButtonTitle: 'Remove all',
  more: 'More',
  form: 'Form',
  formTitle:
    'Select the services you are interested in and fill out the form so that we can contact you.',
};
